'use client'

import { useState } from 'react'
import { useLanguage } from '@/contexts/LanguageContext'
import { FeedbackModal } from '@/components/Feedback/FeedbackModal'

export function Footer() {
  const { t } = useLanguage()
  const [featureModalOpen, setFeatureModalOpen] = useState(false)
  const [bugModalOpen, setBugModalOpen] = useState(false)

  return (
    <footer className="border-t border-gray-200 bg-white flex-shrink-0">
      <div className="max-w-full px-4 sm:px-6 lg:px-8 py-4 text-center">
        <p className="text-xs text-gray-500 m-0">
          <a
            href="https://renosparkstenantsunion.org"
            className="text-rstu-red hover:text-rstu-red-dark font-medium"
          >
            {t('footer.mainSite')}
          </a>
          {' · '}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSc4Fgq0sW7BFHfFLDvM8NIUIKLtnkDTC9RwUQ1rLin8ZqyoSQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-gray-900"
          >
            {t('footer.becomeOrganizer')}
          </a>
          {' · '}
          <button
            onClick={() => setFeatureModalOpen(true)}
            className="text-gray-500 hover:text-gray-700"
          >
            {t('footer.suggestFeature')}
          </button>
          {' · '}
          <button
            onClick={() => setBugModalOpen(true)}
            className="text-gray-500 hover:text-gray-700"
          >
            {t('footer.reportBug')}
          </button>
          {' · '}
          <span>{t('footer.copyright')}</span>
        </p>
      </div>

      {/* Feedback Modals */}
      <FeedbackModal
        isOpen={featureModalOpen}
        onClose={() => setFeatureModalOpen(false)}
        type="feature"
      />
      <FeedbackModal
        isOpen={bugModalOpen}
        onClose={() => setBugModalOpen(false)}
        type="bug"
      />
    </footer>
  )
}
